import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </div>
              <span className="font-heading text-lg font-bold text-white whitespace-nowrap">
                91精品影视
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              91精品影视APP - 您的掌上私人影院。海量高清影视资源，随时随地畅享观影乐趣。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4 whitespace-nowrap">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">分类浏览</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
              <li><a href="#download" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">APP下载</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4 whitespace-nowrap">热门分类</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/category" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">热门推荐</Link></li>
              <li><Link to="/category" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">最新上映</Link></li>
              <li><Link to="/category" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">国产剧集</Link></li>
              <li><Link to="/category" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">海外剧集</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4 whitespace-nowrap">联系我们</h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-primary-400"></i>
                <span>support@91jingpinys.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-customer-service-2-line text-primary-400"></i>
                <span>在线客服 7×24小时</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-shield-check-line text-primary-400"></i>
                <span>正版认证 · 安全下载</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500 whitespace-nowrap">
              &copy; {currentYear} 91精品影视 版权所有 | 仅供学习交流使用
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}